import { render } from "./CustomerTraffic.vue?vue&type=template&id=4272f225&scoped=true"
import script from "./CustomerTraffic.vue?vue&type=script&lang=js"
export * from "./CustomerTraffic.vue?vue&type=script&lang=js"

import "./CustomerTraffic.vue?vue&type=style&index=0&id=4272f225&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4272f225"]])

export default __exports__